import React, { useEffect, useState } from "react";
import Countdown from "react-countdown";
import { useHistory, useLocation } from "react-router-dom";
import FullScreenLoader from "../../../components/fullScreenLoader/fullScreenLoader";
import dummyQueJson from "../../../helper/constant/dummyQue.json";
import { getFullScreen } from "../../../helper/fullscreen";
import { setLocalStorage } from "../../../helper/localStorage";
import { HelperContext } from "../../../store/helperStore";
import { LaunchTestContext } from "../../../store/launchTestStore";
import StartedAmazeTest from "./startedAmazeTest";

const CountdownTest = (props) => (
  // false ?
  <div className="test-instruction-blk">
    <Countdown
      date={Date.now() + 3000}
      onComplete={() => props.setIsTimerStart(false)}
      renderer={({ seconds }) => {
        return <span className="timer">{seconds}</span>;
      }}
    />
  </div>
);
const MyCountdown = React.memo(CountdownTest);

function MyAmazeTest() {
  console.log("inside amaze run");
  const history = useHistory();
  const location = useLocation();

  //context data
  const { helperC, dispatchHelper } = HelperContext();
  const { launchTestC, dispatchLaunchTest } = LaunchTestContext();
  const { launchTestData } = launchTestC;

  const [isTimerStart, setIsTimerStart] = useState(true);
  const [warningState, setWarningState] = useState(0);
  // go back to test after 3 time screen resize

  useEffect(() => {
    if (helperC.FSRemoveCount > 2) {
      history.goBack();
    }
  }, [helperC]);

  useEffect(() => {
    dispatchHelper({ type: "IS_REPLAY", payload: true }); // only inclusive for audio test without replay feature
    dispatchHelper({ type: "IS_START_TIME", payload: false }); // only inclusive for audio test without replay feature

    // if test is type of demo
    if (helperC.testType === "DEMO") {
      handleDemo();
    }
    if (helperC.testType === "") {
      console.log("runrun", launchTestC.reserveTestData);
      dispatchLaunchTest({
        type: "RUNNING_TEST_DATA",
        payload: JSON.parse(localStorage.getItem("RESERVE_TEST_DATA")),
      });
      dispatchHelper({
        type: "RUNNING_QUES_ID",
        payload: launchTestC.reserveTestId,
      });
    }

    const handleBeforeunload = (event) => {
      // Cancel the event as stated by the standard.
      event.preventDefault();
      setLocalStorage("isScreenReloaded", true);
      // Older browsers supported custom message
      event.returnValue = "";
    };

    document.addEventListener("fullscreenchange", exitHandler);
    document.addEventListener("webkitfullscreenchange", exitHandler);
    document.addEventListener("mozfullscreenchange", exitHandler);
    document.addEventListener("MSFullscreenChange", exitHandler);
    window.addEventListener("beforeunload", handleBeforeunload);

    return () => {
      document.removeEventListener("fullscreenchange", exitHandler);
      document.removeEventListener("webkitfullscreenchange", exitHandler);
      document.removeEventListener("mozfullscreenchange", exitHandler);
      document.removeEventListener("MSFullscreenChange", exitHandler);
      window.removeEventListener("beforeunload", handleBeforeunload);
      // setIsFullScreen(false);
    };
  }, []);

  function exitHandler() {
    if (
      !document.fullscreenElement &&
      !document.webkitIsFullScreen &&
      !document.mozFullScreen &&
      !document.msFullscreenElement
    ) {
      setWarningState(1);
    }
  }

  const handleBackToTest = () => {
    getFullScreen();
    setWarningState(0);
  };

  const handleBackToHome = () => {
    history.goBack();
  };

  const handleDemo = () => {
    setIsTimerStart(true);
    const dummyTest = dummyQueJson.data.find(
      (dummyQue) => launchTestData.data[0].demo.test_id === dummyQue.test_id
    );

    let demoQues = dummyTest;

    launchTestData.data[0].que = [demoQues];

    const isCustomId =
      launchTestData.data[0].test_format === "tap_letter" ||
      launchTestData.data[0].test_format === "listen_speak_series";
    const FNMix = launchTestData.data[0].test_format === "visual_facename_mix";

    dispatchLaunchTest({
      type: "RUNNING_TEST_DATA",
      payload: launchTestData,
    });

    // const isFNMid = res.data.data[0].test_format === "visual_facename_mix";
    dispatchHelper({
      type: "RUNNING_QUES_ID",
      payload: isCustomId ? 1 : FNMix ? "11862" : demoQues.id,
    });
  };

  return (
    <div className="amaze-started-test">
      {!launchTestC.err && isTimerStart ? (
        // false
        <MyCountdown setIsTimerStart={setIsTimerStart}></MyCountdown>
      ) : (
        <StartedAmazeTest />
      )}

      {warningState === 1 && (
        <FullScreenLoader
          comingFrom={location.state.routeFrom}
          msg="You exited full screen, Your test is still running"
          handleBackToTest={handleBackToTest}
          handleBackToHome={handleBackToHome}
        ></FullScreenLoader>
      )}
    </div>
  );
}

export default function AmazeTest() {
  // as soon as user accept reloading he/she
  // will go back to test list page
  // data flag using in local storage
  const history = useHistory();
  useEffect(() => {
    const isReloaded = JSON.parse(localStorage.getItem("isScreenReloaded"));
    isReloaded && history.goBack();
  }, []);

  return <MyAmazeTest />;
}
